import { OrbManager } from '../orbs/OrbManager';
import ChatWindow from '../services/chatbox/ChatWindow';
import { AbilityMode } from '../services/hud/AbilityHUD';
import SceneManager from '../core/SceneManager';
import { WorldRegistry } from '../services/creation/worlds/WorldRegistry';
import { AuthScaffold } from './auth/AuthScaffold';
import { AudioBus } from '../services/audio/AudioBus';
class GlobalState {
    constructor() {
        this.maxRendererPixelRatio = 2.5;
        this.rendererPixelMode = 'crisp';
        this.legacyMaxRendererPixelRatio = 2.5;
        this.reducedMaxRendererPixelRatio = 1.5;
        this.safeModeEnabled = false;
        this.safeModeReason = null;
        this.dataWorkerEnabled = false;
        this.renderWorkerEnabled = false;
        this.renderWorkerSupported = false;
        this.renderWorkerSupportReason = null;
        this.renderWorkerWebglSupported = false;
        this.renderWorkerSession = null;
        this.renderWorkerContextLost = false;
        this.currentObject = null;
        this.clickMode = AbilityMode.InspectObject; //this is the starting ability
        this.warpInProgress = false;
        this.isHoldingOrb = false;
        // ——— Routing helpers ———
        this.routing = {
            suppressHistoryUpdate: false,
        };
        // ——— Interaction state ———
        this.connectSelection = null; // click-to-click
        this.connectDrag = { from: null, previewLine: null };
        this.isDragging = false;
        this.lastDragTargetPos = null;
        this.dragTargetObject = null;
        this.dragDistance = 0; // maintains relative distance while dragging
        this.attractAllMode = false; // toggle this on via ability activation
        this.baseTimeGap = 200; // default time gap for spraying orbs
        this.orbitingTarget = null;
        this.autofly = {
            active: false,
            speed: 120,
        };
        this.orbSetInversionActive = false;
        // ——— HUD metadata ———
        this.hudCurrentWorld = 'system';
        this.hudLastSelectedOrbType = '—';
        this.hudWorldsLoaded = 0;
        this.hudOrbRegistryCount = 0;
        this.hudSemanticContext = [];
        this.hudOrbSetInversionState = 'Subset';
        this.hudDirty = {
            currentWorld: true,
            lastSelectedOrbType: true,
            worldsLoaded: true,
            orbRegistryCount: true,
            semanticContext: true,
            orbSetInversionState: true,
        };
        //Misc world stuff
        this.arenaSize = 700;
        // ——— Scene history for unload policy ———
        this.previousSceneName = null;
        this.previousPreviousSceneName = null;
        // ——— Cached per-scene movement policy (no per-frame lookups) ———
        this.cachedSceneName = 'default';
        this.cachedHasRadiusCap = false;
        this.cachedRadiusCap = 0;
        this.cachedHasFloorCap = true; // legacy default (floor at y=2)
        this.cachedFloorY = 2;
        // ——— Blocker state (variables only) ———
        this.isBlocked = true; // start blocked
        console.log('[Bootstrap] Constructing global state');
        this.sceneManager = SceneManager.getInstance();
        this.scene = this.sceneManager.getScene();
        this.worldRegistry = new WorldRegistry();
        this.audioBus = new AudioBus();
        this.auth = new AuthScaffold();
        console.log('[Bootstrap] Core managers ready', {
            scene: this.sceneManager.getCurrentSceneName(),
        });
        this.hudCurrentWorld = this.sceneManager.getCurrentSceneName();
        this.hudWorldsLoaded = this.sceneManager.listScenes().length;
        const updateWorldCount = () => {
            this.hudWorldsLoaded = this.sceneManager.listScenes().length;
            this.hudDirty.worldsLoaded = true;
            console.log('[Bootstrap] Scene count updated', { count: this.hudWorldsLoaded });
        };
        this.sceneManager.on('currentChanged', ({ sceneName }) => {
            this.hudCurrentWorld = sceneName;
            this.hudDirty.currentWorld = true;
            console.log('[Bootstrap] Active scene changed', { sceneName });
        });
        this.sceneManager.on('sceneCreated', updateWorldCount);
        this.sceneManager.on('sceneDeleted', updateWorldCount);
        updateWorldCount();
        this.orbManager = OrbManager.getInstance();
        this.hudOrbRegistryCount = this.orbManager.getFetcherCount();
        this.hudDirty.orbRegistryCount = true;
        console.log('[Bootstrap] Orb manager ready', {
            fetcherCount: this.hudOrbRegistryCount,
        });
        this.orbManager.onFetchersChanged(count => {
            this.hudOrbRegistryCount = count;
            this.hudDirty.orbRegistryCount = true;
            console.log('[Bootstrap] Orb fetcher count changed', { count });
        });
        this.chat = new ChatWindow();
        console.log('[Bootstrap] Chat window initialized');
    }
    setSemanticContext(context) {
        this.hudSemanticContext = Array.isArray(context) ? [...context] : [];
        this.hudDirty.semanticContext = true;
    }
}
export const global = new GlobalState();
